import { create } from 'zustand';
import i18n, { LANGUAGE_STORAGE_KEY, type AppLanguage } from '@/i18n';
import { hasAuthMarkerCookie } from '@/utils/authSession';
import { updateLanguagePreference } from '@/services/auth';

/**
 * 语言偏好的单一事实源（zustand 单例，规避 Redux update-user 整包覆盖回跳）。
 * setLang 副作用：写 localStorage + 切 i18next（<html lang> 由 i18n 的 languageChanged 同步）。
 * 登录态后端持久化（PATCH /api/user/preferences）在 Phase 3 后端接口上线后接入。
 */
export function applyAppLanguage(lang: AppLanguage): void {
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  } catch {
    // 存储不可用时忽略，仅本次会话生效
  }
  void i18n.changeLanguage(lang);
}

interface LanguageState {
  lang: AppLanguage;
  setLang: (lang: AppLanguage) => void;
}

export const useLanguageStore = create<LanguageState>((set) => ({
  lang: i18n.language === 'en' ? 'en' : 'zh-CN',
  setLang: (lang) => {
    applyAppLanguage(lang);
    set({ lang });
    // 登录态写回后端；未登录仅本地生效。失败不回滚（本地优先）
    if (hasAuthMarkerCookie()) {
      void updateLanguagePreference(lang).catch(() => {
        // 忽略后端写回失败
      });
    }
  },
}));
